// import React from 'react';
// import NoNet from '../images/impulse/noNet.svg'
// export default function Widget() {

//     function reloadPage(){
//         window.location.reload()
//     }

//     return (
//          <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
//          <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', border: '2px dashed gray', width: '600px', height: '240px', borderRadius: '20px' }}>
//              <div style={{ textAlign:'center'}}>
//                  <h4 style={{ fontSize: '22px'}}>No Internet Connection</h4>
//                  <p style={{ fontSize: '16px', margin: '0px'}}>Your connection appears to be off-line.</p>
//                  <p style={{fontSize: '16px'}}>Try to refresh the page.</p>
//                  <button style={{padding: '6px 20px', borderRadius: '10px', border: '1px solid gray'}} onClick={reloadPage}>Refresh</button>
//              </div>
//              <div style={{ textAlign:'center' }}>
//                 <img style={{ width: '200px', }}src={NoNet} alt='error'/>
//              </div>
//          </div>
//      </div>
//     );
// }

import React from 'react';
import NoNet from '../images/impulse/noNet.svg';
import ServerError from '../images/impulse/serverError.svg'; // Import your server error image
import TimeOut from '../images/impulse/timeOut.svg'; // Import your server error image

const errorMessages = {
    ERR_NETWORK: {
        title: 'No Internet Connection',
        message: 'Your connection appears to be off-line from the server side.',
        suggestion: 'Try to refresh the page.',
        image: NoNet,
    },
    ServerError: {
        title: 'Internal Server Error',
        message: 'There was an issue with the server.',
        suggestion: 'Please contact the administrator for more information.',
        image: ServerError,
    },
    Timeout: {
        title: 'Timeout',
        message: 'The server took too long to respond.',
        suggestion: 'Please try again later or contact the administrator.',
        image: TimeOut,
    }
};

export default function Widget({ errorType }) {
    const errorInfo = errorMessages[errorType] || errorMessages['ERR_NETWORK'];

    function reloadPage() {
        window.location.reload();
    }

    return (
        <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
            <div style={{ padding: '15px',display: 'flex', justifyContent: 'space-around', alignItems: 'center', border: '2px dashed gray', width: '600px', height: '240px', borderRadius: '20px' }}>
                <div style={{ textAlign: 'center' }}>
                    <h4 style={{ fontSize: '22px', fontWeight:600 }}>{errorInfo.title}</h4>
                    <p style={{ fontSize: '16px', margin: '0px',color:'#2b2a2a' }}>{errorInfo.message}</p>
                    <p style={{ fontSize: '16px', color:'#989494' }}>{errorInfo.suggestion}</p>
                    <button style={{ padding: '6px 30px', borderRadius: '20px', border: '2px solid #396fed', background:'#fff',color:'#396fed' }} onClick={reloadPage}>Refresh</button>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <img style={{ width: '200px' }} src={errorInfo.image} alt='error'/>
                </div>
            </div>
        </div>
    );
}
